'use strict';

angular
    .module('app')
    .run([
        '$rootScope',
        '$state',
        '$stateParams',
        '$location',
        '$window',
        '$timeout',
        '$ngConfirmDefaults',
        'AccessManagerService',
        function(
            $rootScope,
            $state,
            $stateParams,
            $location,
            $window,
            $timeout,
            $ngConfirmDefaults,
            AccessManagerService
        ) {
            $rootScope.$state = $state;
            $rootScope.$stateParams = $stateParams;

            $rootScope.$layout = function(layout) {
                return $stateParams.layout === layout;
            };

            $ngConfirmDefaults.onOpen = function() {
                $timeout(function() {
                    $window.dispatchEvent(new Event('resize'));
                }, 500);
            };

            function _redirection(to) {
                if (!AccessManagerService.isAutenticated()) {
                    return false;
                }

                if (to.abstract) {
                    return false;
                }

                if (['access'].indexOf(to.module) >= 0) {
                    return false;
                }

                if (AccessManagerService.hasPuescLimitation()) {
                    if (['app.puesc'].indexOf(to.name) < 0) {
                        return 'app.puesc';
                    }

                    return false;
                }

                if (['app.object'].indexOf(to.name) >= 0) {
                    return false;
                }

                var accesses = AccessManagerService.list();

                if (accesses[to.name] === false) {
                    return 'app.object';
                }

                return false;
            }

            $rootScope.$on('$stateChangeStart', function(event, to) {
                $rootScope.mobileNavigationOn = false;

                var dropdowns = angular.element('.dropdown-menu');
                dropdowns.css({ display: 'none' });

                $timeout(function() {
                    dropdowns.css({ display: '' });
                }, 100);

                var redirection = _redirection(to);

                if (!redirection) {
                    return true;
                }

                event.preventDefault();
                $rootScope.$broadcast('$stateChangeError');

                $timeout(function() {
                    $rootScope.$broadcast('showAccessPermissionMessage');
                }, 500);

                $state.go(redirection);
            });

            $rootScope.$on('$stateChangeError', function() {
                $timeout(function() {
                    $rootScope.$broadcast('$resetButterbar');
                }, 100);
            });

            $rootScope.$on('$stateChangeSuccess', function(event, to) {
                if ($window.ga) {
                    $window.ga('send', 'pageview', $location.path());
                }

                var redirection = _redirection(to);

                if (!redirection) {
                    return true;
                }

                event.preventDefault();
                $state.go(redirection);
            });
        },
    ])
    .config([
        '$stateProvider',
        '$urlRouterProvider',
        '$locationProvider',
        'csReactProvider',
        'distribution',
        function($stateProvider, $urlRouterProvider, $locationProvider, csReactProvider, distribution) {
            function isSmartDevice() {
                var ua = window.navigator.userAgent || window.navigator.vendor || window.opera;
                return /iPhone|iPod|iPad|Silk|webOS|Android|BlackBerry|Opera Mini|IEMobile/.test(ua);
            }

            $locationProvider.html5Mode({
                enabled: true,
            });

            $urlRouterProvider.otherwise('/app/object');

            if (csReactProvider.isReactDefaultVersion()) {
                if (((document || {}).referrer) !== undefined) {
                    if (typeof document.referrer === 'string') {
                        if (document.referrer.indexOf(distribution.react.url) === -1) {
                            location.href = distribution.react.url;

                            return false;
                        } else {
                            csReactProvider.unsetReactDefaultVersion(distribution.defaults.domain);
                        }
                    }
                }
            }

            $stateProvider
                .state('version', {
                    url: '/versions',
                    templateUrl: 'tpl/version.html',
                })
                .state('app', {
                    abstract: true,
                    url: '/app',
                    templateUrl: 'tpl/layouts/app.html',
                    resolve: checkSession(),
                    params: { layout: 'layout' },
                })
                .state('app.object', {
                    url: '/object',
                    templateUrl: isSmartDevice() ? 'tpl/object.mobile.html' : 'tpl/object.html',
                })
                .state('app.route', {
                    url: '/route',
                    templateUrl: isSmartDevice() ? 'tpl/route.mobile.html' : 'tpl/route.html',
                })
                .state('app.report', {
                    url: '/report',
                    templateUrl: 'tpl/report.html',
                    params: { type: null },
                })
                .state('app.settings', {
                    url: '/settings',
                    templateUrl: 'tpl/settings.html',
                })
                .state('app.link', {
                    url: '/link',
                    templateUrl: 'tpl/link.html',
                })
                .state('app.ngeosent', {
                    url: '/geosentv2',
                    templateUrl: 'tpl/puesc.html',
                    params: { puescType: 'geosent' },
                })
                .state('app.puesc', {
                    url: '/puesc',
                    templateUrl: 'tpl/puesc.html',
                })
                .state('app.puesc-management', {
                    url: '/puesc-management',
                    templateUrl: 'tpl/puesc-management.html',
                })
                .state('app.service', {
                    url: '/service',
                    templateUrl: 'tpl/service.html',
                })
                .state('app.groups', {
                    url: '/groups',
                    templateUrl: 'tpl/groups.html',
                })
                .state('app.shares', {
                    url: '/shares',
                    templateUrl: 'tpl/shares.html',
                })
                .state('app.logins', {
                    url: '/logins',
                    templateUrl: 'tpl/logins.html',
                })
                .state('app.drivers', {
                    url: '/drivers',
                    templateUrl: 'tpl/drivers.html',
                })
                .state('app.hybrid', {
                    url: '/hybrid',
                    templateUrl: 'tpl/hybrid.html',
                })
                .state('app.messages', {
                    url: '/messages',
                    templateUrl: 'tpl/messages.html',
                })
                .state('app.worktime_setting', {
                    url: '/worktime-setting',
                    templateUrl: 'tpl/worktime_setting.html',
                })
                .state('app.application_setting', {
                    url: '/application-setting',
                    templateUrl: 'tpl/application_setting.html',
                })
                .state('app.planning', {
                    url: '/planning',
                    templateUrl: 'tpl/planning.html',
                    params: { object: {} },
                })
                .state('app.harmonograms', {
                    abstract: true,
                    template: '<div ui-view class="fade-in-up"></div>',
                    url: '/harmonograms',
                    params: { object: {} },
                })
                .state('app.harmonograms.vehicles', {
                    url: '/vehicles',
                    templateUrl: 'tpl/harmonograms.html',
                    params: { tab: 'vehicles' },
                })
                .state('app.harmonograms.schedules', {
                    url: '/schedules',
                    templateUrl: 'tpl/harmonograms.html',
                    params: { tab: 'schedules' },
                })
                .state('app.harmonograms.history', {
                    url: '/history',
                    templateUrl: 'tpl/harmonograms.html',
                    params: { tab: 'history' },
                })
                .state('app.harmonograms.cards', {
                    url: '/cards',
                    templateUrl: 'tpl/harmonograms.html',
                    params: { tab: 'cards' },
                })
                .state('app.harmonograms.files', {
                    url: '/files',
                    templateUrl: 'tpl/harmonograms.html',
                    params: { tab: 'files' },
                })
                .state('app.messenger', {
                    url: '/messenger',
                    templateUrl: 'tpl/messenger.html',
                })
                .state('preview', {
                    abstract: true,
                    url: '/preview',
                    templateUrl: 'tpl/layouts/app.html',
                    params: { layout: 'guest' },
                })
                .state('preview.link', {
                    url: '/link/:hash',
                    templateUrl: isSmartDevice() ? 'tpl/preview.mobile.html' : 'tpl/preview.html',
                })
                .state('access', {
                    abstract: true,
                    module: 'access',
                    url: '/access',
                    templateUrl: 'tpl/layouts/access.html',
                    params: { layout: 'access' },
                })
                .state('app.cameras', {
                    url: '/cameras',
                    templateUrl: 'tpl/cameras.html',
                })
                .state('access.logout', {
                    module: 'access',
                    resolve: logout(),
                })
                .state('access.login', {
                    module: 'access',
                    url: '/login/:email',
                    templateUrl: 'tpl/signin.html',
                })
                .state('access.eto', {
                    module: 'access',
                    url: '/eto/:hash',
                    templateUrl: 'tpl/eto.html',
                });

            function checkSession() {
                return {
                    user: [
                        'sessionCheck',
                        function(sessionCheck) {
                            return sessionCheck.check();
                        },
                    ],
                };
            }

            function logout() {
                return {
                    user: [
                        '$http',
                        '$state',
                        'sessionCheck',
                        function($http, $state, sessionCheck) {
                            sessionCheck.userLoggedOutCallback();

                            return $http.delete('/rest-api/auth').then(
                                function() {
                                    $state.go('access.login');
                                },
                                function() {
                                    $state.go('access.login');
                                }
                            );
                        },
                    ],
                };
            }
        },
    ])
    .factory('sessionCheck', [
        '$http',
        '$localStorage',
        '$cookies',
        '$state',
        '$rootScope',
        'AccessManagerService',
        function($http, $localStorage, $cookies, $state, $rootScope, AccessManagerService) {
            var userLoggedOutCallback = function() {
                delete $localStorage.csrf;
                $cookies.remove('jwt_access');

                $localStorage.isSignedIn = false;
                AccessManagerService.update(false);
            };

            return {
                check: function() {
                    return $http.get('/rest-api/auth/data').then(
                        function(response) {
                            var authenticated = (response || {}).data || {};

                            if (authenticated.loginId !== void 0) {
                                $localStorage.isSignedIn = true;

                                $rootScope.$broadcast('updateUserData', authenticated);
                            } else {
                                userLoggedOutCallback();

                                $state.go('access.login');
                            }
                        },
                        function() {
                            userLoggedOutCallback();

                            $state.go('access.login');
                        }
                    );
                },
                userLoggedOutCallback: userLoggedOutCallback,
            };
        },
    ]);
